"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _units = require("../../theme/units");

var _RadioButton = _interopRequireDefault(require("../RadioButton"));

var _Stack = _interopRequireDefault(require("../../layout/Stack"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var GroupContainer = (0, _styledComponents["default"])(_Stack["default"]).withConfig({
  displayName: "RadioButtonGroup__GroupContainer",
  componentId: "zx4rhe-0"
})(function (props) {
  return (0, _styledComponents.css)(["border:0;", " ", " ", ""], props.justified && (0, _styledComponents.css)(["& label{width:100%;}"]), props.justified && props.leftAligned && (0, _styledComponents.css)(["label{text-align:right;}"]), props.hasSeparators && (0, _styledComponents.css)(["> label:not(:last-child) span{border-bottom:1px solid ", ";}"], props.theme.color.structure));
});
/**
 *
 * ### A component for grouping a set of `RadioButton` components.

The **RadioButtonGroup** is designed to group **RadioButton** components. It provides group context to the **RadioButton**s passed as children, such as `groupName`, and handles `onChange` events at the higher level.

### Importing
`import RadioButtonGroup from '@blueprism/ui-core/components/RadioButtonGroup';`
 */

var RadioButtonGroup = function RadioButtonGroup(_ref) {
  var children = _ref.children,
      name = _ref.name,
      _ref$hasSeparators = _ref.hasSeparators,
      hasSeparators = _ref$hasSeparators === void 0 ? false : _ref$hasSeparators,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? _units.formAlign.left : _ref$align,
      _ref$displayType = _ref.displayType,
      displayType = _ref$displayType === void 0 ? _units.formDisplayType["default"] : _ref$displayType,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      rest = _objectWithoutProperties(_ref, ["children", "name", "hasSeparators", "value", "align", "displayType", "onChange"]);

  return /*#__PURE__*/_react["default"].createElement(GroupContainer, _extends({
    element: "fieldset",
    gap: "xs",
    hasSeparators: hasSeparators,
    justified: displayType === _units.formDisplayType.justified,
    leftAligned: align === _units.formAlign.left
  }, rest), _react["default"].Children.map(children, function (child) {
    return child.type === _RadioButton["default"] && /*#__PURE__*/_react["default"].cloneElement(child, {
      name: name,
      checked: value === child.props.value,
      align: align,
      displayType: displayType,
      onChange: onChange
    });
  }));
};

var _default = RadioButtonGroup;
exports["default"] = _default;